module.exports = __webpack_public_path__ + "img/image161.2a2f76a0.png";